import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import GuideArticle from "../pages/article-guide/page";
import ReviewArticle from "../pages/article-review/page";
import TemplatesArticle from "../pages/article-templates/page";
import SecurityArticle from "../pages/article-security/page";
import ComparisonArticle from "../pages/article-comparison/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/vigorbuy-spreadsheet-guide",
    element: <GuideArticle />,
  },
  {
    path: "/vigorbuy-spreadsheet-review",
    element: <ReviewArticle />,
  },
  {
    path: "/vigorbuy-spreadsheet-templates",
    element: <TemplatesArticle />,
  },
  {
    path: "/vigorbuy-spreadsheet-security",
    element: <SecurityArticle />,
  },
  {
    path: "/vigorbuy-spreadsheet-comparison",
    element: <ComparisonArticle />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;